import FragmentedOrderModalComponent from './FragmentedOrderModalComponent'

export default FragmentedOrderModalComponent
